export { default } from './es/icons/ErrorFilled';